import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { getCurrencyMeta } from '../../../../../utils/currency';

function fmt(minor, currency='GBP') {
  const { decimals, symbol } = getCurrencyMeta(currency);
  return `${symbol}${(Number(minor||0)/Math.pow(10,decimals)).toFixed(decimals)}`;
}

export default function RefundsSection({ db, teamId, eventId }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!teamId || !eventId) return;
    (async () => {
      setBusy(true);
      try {
        // gather refunds by iterating tickets
        const tSnap = await getDocs(collection(db, `teams/${teamId}/events/${eventId}/tickets`));
        const all = [];
        for (const t of tSnap.docs) {
          const rSnap = await getDocs(collection(db, `teams/${teamId}/events/${eventId}/tickets/${t.id}/refunds`));
          rSnap.forEach(r => all.push({ id: r.id, ticketId: t.id, ...r.data() }));
        }
        // newest first
        all.sort((a,b) => (b.createdAt?.toMillis?.()||0) - (a.createdAt?.toMillis?.()||0));
        setRows(all);
      } finally {
        setBusy(false);
      }
    })();
  }, [db, teamId, eventId]);

  return (
    <>
      <h3 style={{ marginTop: 16 }}>Refunds</h3>
      <div className="card">
        <div className="card-body">
          {busy ? 'Loading…' : rows.length === 0 ? 'No refunds yet.' : (
            <div className="table wrap">
              <div className="table-row table-head" style={{ gridTemplateColumns: '1.4fr .9fr 1.2fr 1fr 1.4fr' }}>
                <div>Ticket</div><div>Amount</div><div>Reason</div><div>Status</div><div>When</div>
              </div>
              {rows.map(r => (
                <div key={`${r.ticketId}:${r.id}`} className="table-row" style={{ gridTemplateColumns: '1.4fr .9fr 1.2fr 1fr 1.4fr' }}>
                  <div>{r.ticketId}</div>
                  <div>{fmt(r.amountMinor, r.currency)}</div>
                  <div>{r.reason || '—'}</div>
                  <div>{r.stripeStatus || '—'}</div>
                  <div>{r.createdAt?.toDate ? r.createdAt.toDate().toLocaleString() : '—'}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
